import { css } from '@emotion/react';
import { SelectionRow } from '@robinhood/design';
import { CssVars } from '@robinhood/design/product/themes';
import { useFragment } from 'react-relay';
import { graphql } from 'relay-runtime';

import { AddressCellFragment$key } from 'src/clients/Network/gql/build/AddressCellFragment.graphql';
import { mkStreetAddress } from 'src/utils/address';

const AddressCellFragment = graphql`
  fragment AddressCellFragment on Address {
    id
    primaryAddressLine
    secondaryAddressLine
    locality
    subdivision
    zip
  }
`;

interface PropsIface {
  address: AddressCellFragment$key;
}

const AddressCell = ({ address }: PropsIface) => {
  const data = useFragment(AddressCellFragment, address);
  const title = mkStreetAddress(data.primaryAddressLine, data.secondaryAddressLine);
  const caption = `${data.locality}, ${data.subdivision} ${data.zip}`;

  return (
    <SelectionRow
      key={data.id}
      title={title}
      caption={caption}
      variant='radioButton'
      value={data.id}
      overrideRootStyles={row}
    />
  );
};

const row = css`
  padding: 24px;
  text-align: left;
  gap: 12px;
`;

export default AddressCell;
